import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { RolesEnum } from "../../../../services/rolesEnum";
import { isAuthorized } from "../../../../services/authService";

// Role-appropriate shortcuts. Role gating mirrors SidebarMenu so the home
// screen never offers a destination the user cannot access.
const LINKS = [
  {
    label: "IP Planning Board",
    path: "/project/planning?ip-planning",
    roles: [RolesEnum.ProjectManager, RolesEnum.SystemAdmin, RolesEnum.Guest],
  },
  {
    label: "Visits Board",
    path: "/project/planning?visits",
    roles: [
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
      RolesEnum.FieldEnumerator,
      RolesEnum.FieldLogistics,
      RolesEnum.Guest,
      RolesEnum.LimitedGuest,
      RolesEnum.DataAnalyst,
    ],
  },
  {
    label: "Tasks",
    path: "/project/planning?tasks",
    roles: [
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
      RolesEnum.FieldLogistics,
      RolesEnum.DataAnalyst,
      RolesEnum.FieldTeamLeader,
      RolesEnum.Guest,
    ],
  },
  {
    label: "Field Logistics",
    path: "/project/planning?logistics",
    roles: [
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
      RolesEnum.FieldLogistics,
      RolesEnum.DataAnalyst,
      RolesEnum.FieldTeamLeader,
      RolesEnum.Guest,
      RolesEnum.FieldEnumerator,
    ],
  },
  {
    label: "Implementation",
    path: "/project/implementation?WaitingForTracking",
    roles: [
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
      RolesEnum.FieldTeamLeader,
      RolesEnum.FieldEnumerator,
      RolesEnum.FieldLogistics,
      RolesEnum.DataAnalyst,
      RolesEnum.Guest,
    ],
  },
  {
    label: "Reporting",
    path: "/project/reporting?FieldTeamStatusBoard",
    roles: [
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
      RolesEnum.FieldTeamLeader,
      RolesEnum.FieldEnumerator,
      RolesEnum.FieldLogistics,
      RolesEnum.DataAnalyst,
    ],
  },
  {
    label: "Data Checks",
    path: "/project/reporting?DataChecks",
    roles: [RolesEnum.ProjectManager, RolesEnum.SystemAdmin, RolesEnum.DataAnalyst],
  },
  {
    label: "Approve Site Visits",
    path: "/project/reporting?SubmittedForApproval",
    roles: [RolesEnum.ProjectManager, RolesEnum.SystemAdmin],
  },
  {
    label: "Completed",
    path: "/project/completed?ReportingList",
    roles: [
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
      RolesEnum.Guest,
      RolesEnum.LimitedGuest,
    ],
  },
  {
    label: "Flags",
    path: "/project/flags?Flags",
    roles: [
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
      RolesEnum.FieldTeamLeader,
      RolesEnum.FieldEnumerator,
      RolesEnum.FieldLogistics,
      RolesEnum.DataAnalyst,
    ],
  },
  {
    label: "IP Management",
    path: "/project/ip-management",
    roles: [
      RolesEnum.ProjectManager,
      RolesEnum.SystemAdmin,
      RolesEnum.FieldCoordinator,
      RolesEnum.FieldTeamLeader,
      RolesEnum.FieldEnumerator,
      RolesEnum.FieldLogistics,
      RolesEnum.DataAnalyst,
      RolesEnum.Guest,
      RolesEnum.LimitedGuest,
    ],
  },
];

const QuickLinksPanel = () => {
  const navigate = useNavigate();
  const links = LINKS.filter((l) => isAuthorized(l.roles));

  return (
    <div className="homePanel">
      <div className="homePanelHead">
        <h3>Quick links</h3>
      </div>
      <div className="homeQuickLinks">
        {links.map((l) => (
          <Button
            key={l.path}
            className="homeQuickLink"
            onClick={() => navigate(l.path)}
          >
            {l.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickLinksPanel;
